
import basicRenderPlugins from './basic';
import inputRenderPlugins from './input';
import selectRenderPlugins from './select';
import complexRenderPlugins from './complex';
import customRenderPlugins from './custom';

export {
  basicRenderPlugins,
  inputRenderPlugins,
  selectRenderPlugins,
  complexRenderPlugins,
  customRenderPlugins
}

export default [...basicRenderPlugins, ...inputRenderPlugins, ...selectRenderPlugins, ...complexRenderPlugins, ...customRenderPlugins];
